import React, { useEffect, useState } from 'react';
import AxiosInstance from "../../helper/AxiosInstance";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { Helmet } from "react-helmet";
import { currencyExchange } from "../../helper/function"
import PaymentLoader from './Componnents/PaymentLoader'

export default function PricingPage() {
    const location = useLocation();
    const [PlanType, setPlanType] = useState({ duration: 1, preLoader: false })
    const [currency, setCurrency] = useState(currencyExchange[0] ?? { currencySymbol: '', currencyRate: 1, countryName: '' })
    const [packages, setPackage] = useState([]);
    const [hrmsInitialTab, setHrmsInitialTab] = useState(6); // Default to "Half Yearly"
    const [hrmsTabInit, setHrmsTabInit] = useState(false);

    // Set initial active tab for HRMS to "Half Yearly" (duration: 6)
    useEffect(() => {
        // helper to detect and set initial HRMS tab on first package fetch
        if (packages.length > 0 && !hrmsTabInit) {
            // Prefer to default HRMS section to duration:6 (half yearly) IF it exists, otherwise first available
            const exists = packages.find((opt) => opt.duration === 6);
            setPlanType((prev) => ({
                ...prev,
                duration: exists ? 6 : packages[0]?.duration
            }));
            setHrmsTabInit(true);
        }
    }, [packages, hrmsTabInit]);

    const fatchPackage = async () => {
        try {
            setPlanType((prev) => ({ ...prev, preLoader: true }))
            const response = await AxiosInstance.get('/public/packages');
            if (response.status === 1) { setPackage(response.data) }
        } catch (err) { } finally {
            setPlanType((prev) => ({ ...prev, preLoader: false }))
        }
    }
    
    useEffect(() => {
        window.scrollTo(0, 0);
        fatchPackage();

        if (location.hash) {
            const element = document.querySelector(location.hash);
            if (element) {
                element.scrollIntoView({
                    behavior: "smooth",
                });
            }
        }
    }, [location]);

    return (
        <>
            <Helmet>
                <title>Affordable Project Management Software | TaskFlier Pricing </title>
            </Helmet>
            {PlanType.preLoader && <PaymentLoader />}
            <div class="pricing-section-one  md-mb-80 bg-gray">
                <div class="fancy-hero-one">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-10 col-lg-11 m-auto">
                                <h2 class="font-rubik plantitle font-20">
                                    Start Your 3-Day Free Trial - <span data-bs-toggle="modal" data-bs-target="#request-for-free-trial" className='text-primary link'> Click Here</span>
                                </h2>
                            </div>
                        </div>
                        <ul class="nav nav-tabs justify-content-center pricing-nav-one">
                            {
                                packages.map((opt, ind) => (
                                    <li class="nav-item" key={opt.duration} onClick={() => setPlanType((prev) => ({ ...prev, duration: opt.duration }))}>
                                        <a class={!ind ? "nav-link btn-sm active" : "nav-link btn-sm"} data-bs-toggle="tab" href={`#packageducation${opt.duration}`}>{opt.durationString}</a>
                                    </li>
                                ))
                            }
                        </ul>

                        <div className='text-center '>
                            {
                                (currencyExchange || []).map((cnty) => {
                                    return (<span className={cnty.id == currency?.id ? 'flags selected' : 'flags'} onClick={() => setCurrency(cnty)}> <img src={cnty.flagIcon} alt={cnty.countryName} /> <span>{cnty.countryName}</span></span>)
                                })
                            }
                        </div>
                    </div>
                    <div class="bubble-one"></div>
                    <div class="bubble-two"></div>
                    <div class="bubble-three"></div>
                    <div class="bubble-four"></div>
                    <div class="bubble-five"></div>
                    <div class="bubble-six"></div>
                </div>

                <div class="pricing-table-area">
                    <img src="images/shape/62.svg" alt="" class="shapes shape-one" />
                    <img src="images/shape/63.svg" alt="" class="shapes shape-two" />
                    <div class="container">
                        <div class="tab-content">
                            {
                                packages.map((opt, ind) => (
                                    <div class={!ind ? "tab-pane active show" : "tab-pane"} id={`packageducation${opt.duration}`}>
                                        <div class="row justify-content-center pricingtbl">
                                            {opt.packages
                                                .filter(val =>
                                                    typeof val.plan === "string" &&
                                                    ["basic", "standard", "premium"].includes(val.plan.trim().toLowerCase())
                                                )
                                                .map((val) => (
                                                    <div class="col-lg-4 col-md-6" key={val.plan}>
                                                        <div class="pr-table-wrapper">
                                                            <div className='most'><span >Most Popular</span></div>
                                                            <div class="pack-name">{val.plan ?? ''}</div>
                                                            <div class="price font-rubik"><sup>{currency?.currencySymbol}</sup>{(val.price / currency.currencyRate).toFixed(2)} </div>
                                                            <div class="bill-cycle fw-semibold"><del>{currency?.currencySymbol}{(val.mrp / currency.currencyRate).toFixed(2)}</del>
                                                                {val.discount ? <span class="badge bg-success-subtle text-success">{val.discount}% OFF</span> : ""}</div>
                                                            <div class="pack-rec font-rubik font-16">{val.objective}</div>
                                                            {val.limitation ? <div class="trial-text font-rubik">Minimum {val.limitation} Users</div> : null}
                                                            <div>{val.plushFeatures ?? ''}</div>
                                                            {val.description ? <div class="pr-feature" dangerouslySetInnerHTML={{ __html: val.description ?? <></> }}></div> : ""}
                                                            <Link to={`/plan/${currency?.id}/${val.packageID}`} class="theme-btn-four">Choose Plan</Link>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>

            <div class="pricing-section-one bg-white">
                <div class="fancy-hero-one">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-10 col-lg-11 m-auto">
                                <h2 class="font-rubik">Compare plans and features.</h2>
                                <p class="sing-in-call font-20">Taskflier Project Management <a href={`/files/taskflier-profile.pdf`} target='_blank' download="" className=' theme-btn-2 fw-500 ' style={{ lineHeight: "40px" }}> <i class="bi bi-download"></i> Download PDF</a></p>
                            </div>
                        </div>
                    </div>
                    <div class="bubble-one"></div>
                    <div class="bubble-two"></div>
                    <div class="bubble-three"></div>
                    <div class="bubble-four"></div>
                    <div class="bubble-five"></div>
                    <div class="bubble-six"></div>
                </div>
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12">
                            <table>
                                <tbody><tr>
                                    <th class="bg-th width-40">
                                        <h5 class="text-uppercase">Taskflier Packages</h5>
                                        <div class="plan-f">(No Monthly Contract Require )</div>
                                    </th>
                                    {packages && packages.map((val) => {
                                        if (val.duration == PlanType.duration) {
                                            return (
                                                <th class="bg-th width-20">
                                                    <h5 class="text-uppercase">{val.plan ?? ''}</h5>
                                                    <div class="plan-price"><sup><small>{currency?.currencySymbol}</small></sup>{(val.price / currency.currencyRate).toFixed(2)} </div>
                                                </th>
                                            )
                                        }
                                    })}
                                </tr>
                                </tbody>
                            </table>
                            <div id="accordion" class="md-mt-60 project">
                                <div class="card">
                                    <div class="card-header" id="headingOne">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"> THE ESSENTIALS </button>
                                        </h5>
                                    </div>
                                    <div id="collapseOne" className="accordion-collapse collapse " data-bs-parent="#accordion" >
                                        <div class="card-body">
                                            <table>
                                                <tbody><tr>
                                                    <td class="text-left width-40"> Projects </td>
                                                    <td class="width-20"> 2 </td>
                                                    <td class="width-20"> Unlimited </td>
                                                    <td class="width-20"> Unlimited </td>
                                                </tr>
                                                    <tr>
                                                        <td class="text-left"> Storage Space </td>
                                                        <td> 5GB </td>
                                                        <td> 100GB </td>
                                                        <td> 120GB </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left"> Project Templates </td>
                                                        <td> - </td>
                                                        <td> 20 </td>
                                                        <td> 30 </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left"> Read-only users </td>
                                                        <td> - </td>
                                                        <td> - </td>
                                                        <td> 10 </td>
                                                    </tr>
                                                </tbody></table>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingThree">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree"> CORE FEATURES</button>
                                        </h5>
                                    </div>
                                    <div id="collapseThree" className="accordion-collapse collapse show " data-bs-parent="#accordion">
                                        <div class="card-body">
                                            <table>
                                                <tbody><tr>
                                                    <td class="text-left width-40">Dashboard </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                </tr>
                                                    <tr>
                                                        <td class="text-left">Projects </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">HRMS
                                                        </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Employees
                                                        </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Clients </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Vendors
                                                        </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="text-left">Tickets
                                                        </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="text-left">Report
                                                        </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>

                                                    <tr>
                                                        <td class="text-left">Appointments
                                                        </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Lead Managment
                                                        </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Collections
                                                        </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Project expense
                                                        </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi-x-square textfalse font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Quotation </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Office expenses
                                                        </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Recurring activities
                                                        </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left">Settings
                                                        </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                </tbody></table>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="headingTwo">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo"> ISSUE TRACKER </button>
                                        </h5>
                                    </div>
                                    <div id="collapseTwo" className="accordion-collapse collapse " data-bs-parent="#accordion">
                                        <div class="card-body">
                                            <table>
                                                <tbody><tr>
                                                    <td class="text-left width-40"> Business Rules </td>
                                                    <td class="width-20"> - </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                </tr>
                                                    <tr>
                                                        <td class="text-left"> Web to Issue Form </td>
                                                        <td> - </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left"> Link Issues </td>
                                                        <td> - </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left"> Custom Fields </td>
                                                        <td> - </td>
                                                        <td> - </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left"> SLA </td>
                                                        <td> - </td>
                                                        <td> - </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="text-left"> Webhooks </td>
                                                        <td> - </td>
                                                        <td> - </td>
                                                        <td> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    </tr>
                                                </tbody></table>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="headingOne">
                                        <h5 class="mb-0">
                                            <button class="btn btn-link" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour"> IN-HOUSE INTEGRATIONS </button>
                                        </h5>
                                    </div>
                                    <div id="collapseFour" className="accordion-collapse collapse " data-bs-parent="#accordion">
                                        <div class="card-body">
                                            <table>
                                                <tbody><tr>
                                                    <td class="text-left width-40"> MNB Project CRM </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                    <td class="width-20"> <i class="bi bi bi-check2-square texttrue font-28"></i> </td>
                                                </tr>

                                                </tbody></table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* HRMS Section */}
            <div class="pricing-section-one pt-80  md-mb-80 mt-80 bg-gray" id="HRMS">
                <div class="fancy-hero-one">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-10 col-lg-11 m-auto">
                                <h6><span class="upper-title custom-name bg-primary text-white mb-2">PRICING</span></h6>
                                <h3 class="font-rubik fw-semibold">HRMS Plans for Every Business</h3>
                            </div>
                            <div class="col-12 m-auto">
                                <p class="font-rubik font-14 pt-2">Choose the perfect plan to streamline your HR operations.</p>
                            </div>
                        </div>
                        <div class="row" hidden>
                            <div class="col-xl-10 col-lg-11 m-auto">
                                <h2 class="font-rubik plantitle font-20">Start Your 3-Day Free Trial - <span data-bs-toggle="modal" data-bs-target="#request-for-free-trial" className='text-primary link'> Click Here</span></h2>
                            </div>
                        </div>
                        <ul class="nav nav-tabs justify-content-center pricing-nav-one">
                            {
                                packages.map((opt) => (
                                    <li
                                        className="nav-item"
                                        key={opt.duration}
                                        onClick={() => setPlanType((prev) => ({ ...prev, duration: opt.duration }))}
                                    >
                                        <a
                                            className={
                                                PlanType && PlanType.duration === opt.duration
                                                    ? "nav-link btn-sm active"
                                                    : "nav-link btn-sm"
                                            }
                                            data-bs-toggle="tab"
                                            href={`#packageducation${opt.duration}`}
                                        >
                                            {opt.durationString}
                                        </a>
                                    </li>
                                ))
                            }
                        </ul>

                        <div className="text-center">
                            {(currencyExchange || []).map((cnty) => (
                                <span
                                    key={cnty.id}
                                    className={cnty.id === currency?.id ? "flags selected" : "flags"}
                                    onClick={() => setCurrency(cnty)}
                                >
                                    <img src={cnty.flagIcon} alt={cnty.countryName} /> <span>{cnty.countryName}</span>
                                </span>
                            ))}
                        </div>
                    </div>
                    <div class="bubble-one"></div>
                    <div class="bubble-two"></div>
                    <div class="bubble-three"></div>
                    <div class="bubble-four"></div>
                    <div class="bubble-five"></div>
                    <div class="bubble-six"></div>
                </div>

                <div class="pricing-table-area">
                    <img src="images/shape/62.svg" alt="" class="shapes shape-one" />
                    <img src="images/shape/63.svg" alt="" class="shapes shape-two" />
                    <div class="container">
                        <div class="tab-content">
                            {/* Only show tab-pane for active duration in HRMS section */}
                            {
                                packages
                                    .filter(opt => PlanType && PlanType.duration === opt.duration)
                                    .map(opt => (
                                        <div
                                            className="tab-pane active show"
                                            id={`packageducation${opt.duration}`}
                                            key={opt.duration}
                                        >
                                            <div class="row justify-content-center pricingtbl">
                                                {opt.packages
                                                    .filter(val => {
                                                        // Only allow plans that are NOT "Basic", "Standard" or "Premium"
                                                        if (!val.plan) return true;
                                                        const planName = val.plan.trim().toLowerCase();
                                                        return !["basic", "standard", "premium"].includes(planName);
                                                    })
                                                    .map(val => (
                                                        <div class="col-lg-4 col-md-6" key={val.packageID}>
                                                            <div class="pr-table-wrapper">
                                                                <div className='most'><span>Most Popular</span></div>
                                                                <div class="pack-name">{val.plan ?? ''}</div>
                                                                <div class="price font-rubik">
                                                                    <sup>{currency?.currencySymbol}</sup>
                                                                    {(val.price / currency.currencyRate).toFixed(2)}
                                                                </div>
                                                                <div class="bill-cycle fw-semibold">
                                                                    <del>{currency?.currencySymbol}{(val.mrp / currency.currencyRate).toFixed(2)}</del>
                                                                    {val.discount ? <span class="badge bg-success-subtle text-success">{val.discount}% OFF</span> : ""}
                                                                </div>
                                                                <div class="pack-rec font-rubik font-16">{val.objective}</div>
                                                                {val.limitation ? <div class="trial-text font-rubik">Minimum {val.limitation} Users</div> : null}
                                                                <div>{val.plushFeatures ?? ''}</div>
                                                                {val.description ? <div class="pr-feature" dangerouslySetInnerHTML={{ __html: val.description ?? <></> }}></div> : ""}
                                                                <Link to={`/plan/${currency?.id}/${val.packageID}`} class="theme-btn-four">Choose Plan</Link>
                                                            </div>
                                                        </div>
                                                    ))}
                                            </div>
                                        </div>
                                    ))
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div class="fancy-feature-thirtyFour pt-80 pb-80 bg-white">
                <div class="container">
                    {/* <div class="title-style-two text-center mb-40 md-mb-40">
                    <h2>
                        <span>
                        Core Components of TaskFlier’s Employee Attendance Tracking
                        </span>
                    </h2>
                    </div> */}
                    <div class="row  features">
                        <div class="col-lg-12 col-12 ">
                            <div class="Solutions-box " >
                                <div class="pack-name">Smart HRMS for Modern Workplaces
                                </div>
                                <hr></hr>
                                <p className="mainp">Manage your entire workforce from a single platform. Taskflier HRMS simplifies attendance, leave, payroll, employee records, recruitment, and performance management, helping your organization save time, reduce manual work, and improve productivity.</p>
                                <ul class="Featurelist">
                                    <li>Employee Management</li>
                                    <li>Attendance & Leave Tracking</li>
                                    <li>Payroll Processing</li>
                                    <li>Recruitment & Onboarding</li>
                                    <li>Employee Self-Service Portal</li>
                                    <li>Reports & Analytics</li>
                                </ul>
                            </div>
                        </div>
                        {/* <div class="col-lg-6 col-12 ">
                        <div class="Solutions-box " >
                            <div class="pack-name">Attendance Monitoring And Time Management On The Go</div>
                            <hr></hr>
                            <ul class="Featurelist">
                                <li>Allow attendance to be captured on any device.</li>
                                <li>Wider reach for teams that are constantly on the move.</li>
                                <li>Location tracking ensures compliance.</li>
                                <li>Allow more freedom with remote work supervision.</li>
                            </ul>
                        </div>
                        </div> */}
                        <div class="col-lg-4 col-12 ">
                            <div class="Solutions-box " >
                                <div class="pack-name">Transform Your HR Operations</div>
                                <hr></hr>
                                <p className='mainp'>From hiring to retirement, Taskflier HRMS streamlines every stage of the employee lifecycle. Automate routine HR tasks, improve employee engagement, and gain complete visibility into your workforce.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-12 ">
                            <div class="Solutions-box ">
                                <div class="pack-name">Everything Your HR Team Needs</div>
                                <hr></hr>
                                <p className='mainp'>Manage employees, attendance, leave, payroll, recruitment, and performance from one centralized HRMS platform designed to simplify workforce management.</p>
                            </div>
                        </div>
                        <div class="col-lg-4 col-12 ">
                            <div class="Solutions-box " >
                                <div class="pack-name">Complete HRMS Solution for Growing Businesses</div>
                                <hr></hr>
                                <p className='mainp'>Taskflier HRMS helps organizations automate HR processes, improve employee experiences, and ensure compliance with ease. From attendance tracking and payroll management to recruitment and performance reviews, everything is managed through a single intelligent platform.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
